import { Container } from './styles'

import logoImg from '../../assets/logo.svg'
import { ReactComponent as PerfilIcon } from '../../assets/person-circle.svg'

import { Link, NavLink } from 'react-router-dom'

export const HeadPerfilLogo = () => {
  return (
    <Container>
      <NavLink to='/users/login'>
        <PerfilIcon />
      </NavLink>
      <Link to='/'>
        <img src={logoImg} alt='logo' />
      </Link>
    </Container>
  )
}
